import { useState, useCallback, useRef } from "react";

const DEFAULT_OPTIONS = {
  onError: null,
  initialData: null,
  initialLoading: false,
  getData: (r) => r.data,
};

export const useAPIRequest = (requestFn, options = {}) => {
  const { onError, initialData, initialLoading, getData } = {
    ...DEFAULT_OPTIONS,
    ...options,
  };

  const [data, setData] = useState(initialData);
  const [loading, setLoading] = useState(initialLoading);
  const [error, setError] = useState(null);

  const getDataRef = useRef(getData);
  const onErrorRef = useRef(onError);

  const execute = useCallback(
    async (...args) => {
      try {
        setLoading(true);
        setError(null);
        const response = await requestFn(...args);
        setData(getDataRef.current(response));
      } catch (err) {
        setError(err);
        onErrorRef.current?.(err);
      } finally {
        setLoading(false);
      }
    },
    [requestFn],
  );

  const reset = useCallback(() => {
    setData(null);
    setError(null);
    setLoading(false);
  }, []);

  return { data, loading, error, execute, reset };
};
